module.exports = __webpack_public_path__ + "img/title.05b99b83.png";